import { type ReactNode } from 'react';
import { RequireCheckedOut } from '@hungryroot/customer';
import { fullPageRedirect } from '@hungryroot/environment';
import { LOGIN_ROUTE } from '@hungryroot/routes';
import { islandRoot } from '../IslandRoot/IslandRoot';

export const RequireCheckedOutIsland = islandRoot(
  ({ children }: { children: ReactNode }) => {
    return (
      <RequireCheckedOut
        onNotCheckedOut={() => {
          window.location.href = '/';
        }}
        onNotLoggedIn={() => {
          fullPageRedirect(`${LOGIN_ROUTE}?next=${window.location.pathname}`);
        }}
      >
        {children}
      </RequireCheckedOut>
    );
  }
);
